export const environment = {
  production: false,
  apiUrl: "https://asah-skill.com/api",
};

// Note:
// production :https://api.asah-skill.com/api
// development: https://api-dev.lakerja.net/api
